
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course",
      function () {
        return require("private-next-pages/course/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course"])
      });
    }
  